import React, { lazy } from 'react';
import RPT from 'prop-types';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import { initRequestProgressBar } from './connection';
import { angularEmit } from './angular.bridge';
import { getFunctionUrl } from '../../../utils';

const List = lazy(() => import('./list/List.component'));
const Details = lazy(() => import('./details/Details.component'));
const Invoke = lazy(() => import('./invoke/Invoke.component'));
const Create = lazy(() => import('./create/Create.component'));

class ZFunctionsApp extends React.Component<any, any> {
    static propTypes = {
        instance: RPT.string.isRequired,
    };

    componentDidMount() {
        initRequestProgressBar();
        angularEmit('zframework:subTitleReload');
    }

    render() {
        return (
            <>
                <div className="main-title-substitute" style={{ display: 'none' }}>
                    Functions
                </div>
                {
                    // @ts-ignore
                    this.props.type === 'list' && <List instance={this.props.instance} />
                }
                {
                    // @ts-ignore
                    this.props.type === 'details' && <Details instance={this.props.instance} />
                }
            </>
        );
    }
}

export const FunctionsRoutes = () => {
    const api = getFunctionUrl() + '/';

    return (
        <Routes>
            <Route path="functions" element={<ZFunctionsApp type={'list'} instance={api} />} />
            <Route path="functions/details/:name" element={<ZFunctionsApp type={'details'} instance={api} />} />
            <Route path="functions/invoke/:name?" element={<Invoke instance={api} />} />
            <Route
                path="functions/create"
                element={
                    <Create
                        instance={api}
                        onCloseClick={() => {
                            window.location.hash = 'functions';
                        }}
                    />
                }
            />

            <Route path="*" element={null} />
        </Routes>
    );
};

export const Functions: React.FC = () => {
    return (
        <Router basename={''}>
            <FunctionsRoutes />
        </Router>
    );
};
